export const environment = {
    production: false,
    defaultauth: 'firebase',
    firebaseConfig: {
        // IMPORTANT: Replace these with your UAT/DEV Firebase project credentials
        // You'll get these from Firebase Console > Project Settings > Your apps
        apiKey: "AIzaSyCzTDQCU1yiv_A7BpUyphXu1n9tPorbb80",
        authDomain: "uat.echo.solenex.it",
        projectId: "echo--uat",
        storageBucket: "echo--uat.firebasestorage.app",
        messagingSenderId: "533461273935",
        appId: "1:533461273935:web:d9a2a87ff93b2ecbfe493a",
        measurementId: "G-8V6ND8E7Z0"  // Get actual ID from Firebase Console > Project Settings > General > Your apps
    },


    whatsapp: {
        // TODO: Replace with your UAT Meta App credentials from Meta for Developers
        // Get these from: https://developers.facebook.com/apps/
        metaAppId: '2141125793408634',
        embeddedSignupConfigId: '1584872973048070'
    },
    push: {
        // Public "Web Push certificate" key from the echo--uat project:
        // Firebase Console > Project settings > Cloud Messaging > Web configuration.
        // Public value, safe to commit. Push stays disabled while this is empty.
        vapidKey: 'BO-PXAN9KfG2l7eipxNJyALP9Rr77vdidfkQPo15GcjnlmI_4sB-5SIXtSHfrYKGxmq0vhzsuN5LiygTZQ-0TU4'
    },
    /**
     * The Echo chat widget Solenex uses for its own customer support.
     *
     * Echo dogfoods its own product here: this is the same widget an Echo
     * customer embeds on their site. The UAT widget is deliberately separate -
     * conversations started here are test traffic and must not reach the
     * production support inbox. Production has its own; see environment.prod.ts.
     */
    support: {
        embedUrl: 'https://uat.api.echo.solenex.it/embed.js',
        widgetId: 'wgt_76UtPHKzCNA6s6zZhOeL-A'
    },
    /**
     * Where the customer app lives.
     *
     * Used for links that cross between the two sites — chiefly the
     * support-session handoff, which the console has to send to this origin
     * because Firebase Auth sessions do not cross one.
     */
    appUrl: 'https://uat.echo.solenex.it',
    /**
     * Where the Solenex platform console lives.
     *
     * The console moved to its own Hosting site, so every link to it from the
     * customer app is now cross-origin and cannot be a routerLink.
     * No UAT platform console exists; call sites fall back when this is empty.
     */
    adminConsoleUrl: '',
    googlePlacesApiKey: 'AIzaSyCpnxHohzxNSnOcpZKn1C6V49bt8Kk7Yc4',
    /**
     * Kill switch for conversation workflows and contact-list automations.
     * Off, they are hidden and refused for every organisation whatever its
     * plan, trials included. Mirrors WORKFLOWS_ENABLED in functions/src/config.
     */
    workflowsEnabled: true
};
